module.exports = __webpack_public_path__ + "static/media/2-3-3_OPP_Rainbow_01.55257921.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Printing-Techniques/2-3-3_OPP_Rainbow_01.jpg
// module id = 1722
// module chunks = 0